import React, { useState } from 'react';
import { Clock, Monitor, LogOut, Activity, Check, AlertTriangle } from 'lucide-react';

const SecuritySettingsModal = ({ setShowSecuritySettings, sessionTimeout, setSessionTimeout, loginHistory, logoutAllDevices, logoutDevice, securityLogs }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end z-50">
      <div className="bg-white w-full max-w-md mx-auto rounded-t-3xl p-6 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Security & Privacy</h2>
          <button onClick={() => setShowSecuritySettings(false)} className="text-gray-500">
            ✕
          </button>
        </div>

        {/* Session Settings */}
        <div className="mb-6">
          <h3 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
            <Clock size={20} className="text-blue-600" />
            Session Settings
          </h3>
          <div className="bg-gray-50 rounded-xl p-4">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-700">Auto-logout timeout</span>
              <select
                value={sessionTimeout}
                onChange={(e) => setSessionTimeout(Number(e.target.value))}
                className="text-sm border border-gray-300 rounded-lg px-3 py-1"
              >
                <option value="600">10 minutes</option>
                <option value="1800">30 minutes</option>
                <option value="3600">1 hour</option>
                <option value="7200">2 hours</option>
              </select>
            </div>
            <p className="text-xs text-gray-500">
              You'll be logged out after this period of inactivity
            </p>
          </div>
        </div>

        {/* Device Management */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-semibold text-gray-800 flex items-center gap-2">
              <Monitor size={20} className="text-purple-600" />
              Active Devices
            </h3>
            <button
              onClick={logoutAllDevices}
              className="text-xs text-red-600 font-medium hover:underline"
            >
              Logout All
            </button>
          </div>
          <div className="space-y-2">
            {loginHistory.map((device) => (
              <div
                key={device.id}
                className="bg-gray-50 rounded-xl p-4 border border-gray-200"
              >
                <div className="flex justify-between items-start mb-2">
                  <div className="flex items-start gap-3">
                    <Monitor size={20} className="text-gray-400 mt-0.5" />
                    <div>
                      <p className="font-semibold text-gray-800 text-sm">
                        {device.device}
                        {device.current && (
                          <span className="ml-2 bg-green-100 text-green-700 text-xs px-2 py-0.5 rounded-full">
                            Current
                          </span>
                        )}
                      </p>
                      <p className="text-xs text-gray-600">{device.location}</p>
                      <p className="text-xs text-gray-500">IP: {device.ip}</p>
                      <p className="text-xs text-gray-400">{device.time}</p>
                    </div>
                  </div>
                  {!device.current && (
                    <button
                      onClick={() => logoutDevice(device.id)}
                      className="text-red-600 hover:bg-red-50 p-1 rounded"
                    >
                      <LogOut size={16} />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Security Audit Logs */}
        <div className="mb-6">
          <h3 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
            <Activity size={20} className="text-green-600" />
            Activity Log
          </h3>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {securityLogs.map((log) => (
              <div
                key={log.id}
                className="bg-gray-50 rounded-xl p-3 border-l-4"
                style={{
                  borderLeftColor:
                    log.type === 'success'
                      ? '#10b981'
                      : log.type === 'warning'
                      ? '#f59e0b'
                      : '#3b82f6'
                }}
              >
                <div className="flex items-start gap-2">
                  {log.type === 'success' && <Check size={16} className="text-green-600 mt-0.5" />}
                  {log.type === 'warning' && <AlertTriangle size={16} className="text-orange-600 mt-0.5" />}
                  {log.type === 'info' && <Activity size={16} className="text-blue-600 mt-0.5" />}
                  <div className="flex-1">
                    <p className="font-semibold text-gray-800 text-sm">{log.action}</p>
                    <p className="text-xs text-gray-600">{log.detail}</p>
                    <p className="text-xs text-gray-400 mt-1">{log.time}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Login History Export */}
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <h4 className="font-semibold text-gray-800 text-sm mb-2">Need your login history?</h4>
          <p className="text-xs text-gray-600 mb-3">
            Download a complete report of all your account activity
          </p>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-all w-full">
            Download Security Report
          </button>
        </div>
      </div>
    </div>
  );
    export default SecuritySettingsModal;